import _ from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


const RenewalTableModel = (props) => {

    const {
        renewalModal,
        setRenewalModal,
        setConfirmModal,
        setModalMsg,
        subscription
    } = props

    const [filterYear, setFilterYear] = useState([])
    const [tableData, setTableData] = useState([])
    const [filterValue, setFilterValue] = useState(1)

    useEffect((() => {
        if (renewalModal) {
            let filterManual = [
                { id: 1, label: 'Last 30 days'},
                { id: 2, label: 'Past 3 months'}
            ]
            const startRangeYear = _.toNumber(moment().format('Y')) - 10
            const endRangeYear = _.toNumber(moment().format('Y')) + 1
            let filterYear = _.reverse(_.map(_.range(startRangeYear, endRangeYear), (row) => {
                return {id: row, label: row}
            }))
            setFilterYear(filterManual.concat(filterYear))
            return () => setFilterValue(1)
        }
    }), [renewalModal])

    useEffect(() => {
        if (!_.isEmpty(subscription.renewal_data)) {
            let renewalInfo = subscription.renewal_data
            let today = moment().endOf('day').unix();
            if (filterValue == 1) {
                let last30Days = moment().subtract(30, 'days').unix()
                setTableData(_.filter(renewalInfo, (row) => {
                    if (today >= row.renewal_date && 
                        row.renewal_date >= last30Days) return row
                }))
            } else if (filterValue == 2) {
                let last90Days = moment().subtract(90, 'days').unix()
                setTableData(_.filter(renewalInfo, (row) => {
                    if (today >= row.renewal_date &&
                        row.renewal_date >= last90Days) return row
                }))
            } else if (filterValue) {
                let lastDateOfYear = moment({year: filterValue}).endOf('Y').unix()
                let startDateOfYear = moment({year: filterValue}).startOf('Y').unix()
                setTableData(_.filter(renewalInfo, (row) => {
                    
                    if (startDateOfYear <= row.renewal_date && 
                        row.renewal_date <= lastDateOfYear) {
                            return row
                    }
                }))
            }
        }
    }, [subscription, filterValue, renewalModal])

    const closeBtn = (
        <button type="button" className="btn-close" aria-label="Close" onClick={() => setRenewalModal(false)}></button>
    )

    return (
        <Modal isOpen={renewalModal} toggle={setRenewalModal}
            id='renewal-table'
            backdrop={false} keyboard={false}
            className=" modal-dialog modalassign modal-dialog-scrollable renewal-modal modal-lg" centered>
            {/* <Modal.Header toggle={setRenewalModal} closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                    <div dangerouslySetInnerHTML={{
                    __html: subscription?.name
                }}></div>
                    </Modal.Title>
                </Modal.Header> */}
            <ModalHeader toggle={setRenewalModal} close={closeBtn}>
                <div className="d-flex gap-2 align-items-center">
                    <div className="modlehead-title" dangerouslySetInnerHTML={{
                        __html: subscription?.name
                    }}></div>
                    <div className="invoice-since d-flex gap-2 align-items-center">
                        <label><b>Invoice Since</b></label>
                        <select className="form-select w-auto"
                            onChange={(e) => {
                                if (e.target.value) {
                                    setFilterValue(e.target.value)
                                }
                            }}
                        >
                            {
                                !_.isEmpty(filterYear) &&_.map(filterYear, (row) => {
                                    return (
                                        <option value={row.id}>{row.label}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="course-info-table">
                <table class="table mb-0 office_list table-striped renewal-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Invoice Number</th>
                            <th>Payment Date</th>
                            <th>Payment Status</th>
                            <th>Invoice</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !_.isEmpty(tableData) ?
                                tableData.map((r, i) => {
                                    return (
                                        <tr>
                                            <td>{i + 1}</td>
                                            <td>{r.stripe_invoice_number}</td>
                                            <td>{moment.unix(r.renewal_date).format('Do MMM YYYY')}</td>
                                            <td style={{textTransform: 'capitalize'}}>{r.renewal_status}</td>
                                            <td>
                                                    <button className='button-reset'
                                                        onClick={() => {
                                                            if (r.subscription_invoice_url) {
                                                                // window.open(r.subscription_invoice_url)
                                                                let filePath = r.subscription_invoice_url
                                                                var link = document.createElement('a');
                                                                link.href = filePath;
                                                                link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
                                                                link.click();
                                                            } else {
                                                                setModalMsg('Invoice pdf not present.')
                                                                setConfirmModal(true)
                                                            }
                                                        }}
                                                    >
                                                        <svg id="Component_115_14" data-name="Component 115 â 14"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                                            width="45"
                                                            height="45"
                                                            viewBox="0 0 30 30">
                                                            <defs>
                                                                <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                                                    <stop offset="0" stopColor="#00b7f1" />
                                                                    <stop offset="1" stopColor="#ed156e" />
                                                                </linearGradient>
                                                            </defs>
                                                            <circle id="Ellipse_57" data-name="Ellipse 57" cx="15" cy="15" r="15" fill="url(#linear-gradient)" />
                                                            <circle id="Ellipse_179" data-name="Ellipse 179" cx="13" cy="13" r="13" transform="translate(2 2)" fill="#fff" />
                                                            <path id="database-export" d="M9.62,3C6.515,3,4,4.257,4,5.81S6.515,8.62,9.62,8.62c.351,0,.7-.021,1.054-.056v-1H12.7l-.7-.7,2.466-2.459A7.748,7.748,0,0,0,9.62,3m4.861,2.866-1,1L15.24,8.62H11.728v1.405H15.24l-1.756,1.756,1,1,3.456-3.456M4,7.215V9.323c0,1.553,2.515,2.81,5.62,2.81a10.5,10.5,0,0,0,2.283-.26l.794-.794H10.674V9.969c-.351.035-.7.056-1.054.056C6.515,10.025,4,8.768,4,7.215m0,3.513v2.108c0,1.553,2.515,2.81,5.62,2.81a7.748,7.748,0,0,0,4.847-1.405l-1.335-1.335a9.473,9.473,0,0,1-3.513.632C6.515,13.538,4,12.28,4,10.728Z" transform="translate(4.6 5.677)" fill="#774d9f" />
                                                        </svg>
                                                    </button>
                                                </td>
                                        </tr>
                                    )
                                })
                                :
                                <tr>
                                    <td colSpan={4}>
                                        No Records found.
                                    </td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            </ModalBody>
        </Modal>
    )
}

export default RenewalTableModel;